module.exports = __webpack_public_path__ + "media/customizations/harvestlife/logo-88b485f5b8cb6fca4d008a881c776118.png";